import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import { withRouter } from 'react-router-dom';

const fadeIn = keyframes`
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0px);
    opacity: 1;
  }
`;

class FadeInAnimation extends Component {
    constructor() {
        super();
        this.state = {
            animation: null,
        };
    }

    componentDidMount() {
        this.setState({ animation: 'fadeIn' });
    }

    componentDidUpdate(prevProps) {
        const { location } = this.props;

        if (location !== prevProps.location) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ animation: 'fadeIn' });
        }
    }

    render() {
        const {
            className,
            children,
            isfadeIn,
            delay = '0',
            duration = '1',
            timing = 'ease-out',
            fillMode = 'forwards',
        } = this.props;
        const { animation } = this.state;

        return (
            <Root
                className={className}
                animation={animation}
                isfadeIn={isfadeIn}
                delay={delay}
                duration={duration}
                timing={timing}
                fillMode={fillMode}
                onAnimationEnd={() => this.setState({ animation: null })}
            >
                {children}
            </Root>
        );
    }
}

const Root = styled.div`
    opacity: ${({ animation }) => (animation ? 0 : 1)};
    animation-delay: ${({ delay }) => delay}s;
    animation-name: ${({ animation }) => ((animation === 'fadeIn' && fadeIn) || 'unset')};
    animation-duration: ${({ duration }) => duration}s;
    animation-timing-function: ${({ timing }) => timing};
    animation-fill-mode: ${({ fillMode }) => fillMode};
`;

export default withRouter(FadeInAnimation);
